/* ---------------------------------------------------------------------
   Minimalist logo: keeps the $25 line and its case together, on every
   page the cart can change on (loaded from layout/theme.liquid).

   The pair (assets/gc-logo-addon.js): the case line carries
   "Logo: Minimalist" + _logo_id, the add-on line _logo_link with the same
   id. The workshop reads the case line; the add-on line is the charge.
   - an add-on line whose case left the cart goes too, and its quantity
     follows the case's (one charge per case);
   - a case whose add-on line was removed goes back to the standard logo:
     "Logo" and _logo_id come off its properties, so nothing is promised
     that is not paid for.
   A pair still being added (gc_logo_pending, under 20 s) is left alone, and
   so is the whole cart while Undo puts lines back (window.__gcCartHold,
   gc-cart-undo.js; Oct 2026): a case and its $25 line come back together.
   Matching is by the properties alone, never by a title or handle, which
   are translated on most of the storefront's languages.
   --------------------------------------------------------------------- */
(function () {
  if (window.__gcLogoSync) return;
  window.__gcLogoSync = true;
  var busy = false, again = false, timer = 0, rounds = 0, graceTimer = 0;

  function prop(line, name) {
    var p = line && line.properties;
    return p && p[name] != null ? String(p[name]) : '';
  }
  function pending() {
    var out = {};
    try {
      var p = JSON.parse(sessionStorage.getItem('gc_logo_pending') || '{}'), now = Date.now(), keep = {};
      for (var k in p) if (now - p[k] < 20000) { out[k] = true; keep[k] = p[k]; }
      sessionStorage.setItem('gc_logo_pending', JSON.stringify(keep));
    } catch (e) {}
    return out;
  }
  function post(url, body) {
    return new Promise(function (resolve) {
      var x = new XMLHttpRequest();
      x.open('POST', url, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.__gcLogoOwn = true;
      x.onloadend = function () { resolve(x.status); };
      x.send(JSON.stringify(body));
    });
  }
  function plan(cart) {
    var fees = {}, cases = {}, wait = pending(), ops = [];
    cart.items.forEach(function (l) {
      var f = prop(l, '_logo_link'); if (f) (fees[f] = fees[f] || []).push(l);
      var c = prop(l, '_logo_id'); if (c) (cases[c] = cases[c] || []).push(l);
    });
    Object.keys(fees).forEach(function (k) {
      var want = (cases[k] || []).reduce(function (n, l) { return n + l.quantity; }, 0);
      /* a pair still in transit: look again once its grace has run out */
      if (!want && wait[k]) { clearTimeout(graceTimer); graceTimer = setTimeout(schedule, 21000); return; }
      fees[k].forEach(function (l, i) {
        var q = i === 0 ? want : 0;
        if (l.quantity !== q) ops.push({ id: l.key, quantity: q });
      });
    });
    Object.keys(cases).forEach(function (k) {
      if (fees[k] || wait[k]) return;
      cases[k].forEach(function (l) {
        /* blank, not deleted: /cart/change.js ignores a properties object that merely
           leaves keys out, and a blank property is shown nowhere (cart, checkout) */
        var p = Object.assign({}, l.properties, { Logo: '', _logo_id: '' });
        ops.push({ id: l.key, quantity: l.quantity, properties: p });
      });
    });
    return ops;
  }
  function held() { return !!(window.__gcCartHold && window.__gcCartHold()); }
  function run() {
    if (busy) { again = true; return; }
    if (held()) { setTimeout(schedule, 300); return; }
    busy = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ops = plan(cart);
        if (!ops.length) { rounds = 0; return; }
        if (held()) { again = true; return; }          /* Undo began while this read the cart */
        if (++rounds > 4) return;                      /* never fight another script forever */
        return ops.reduce(function (p, op) { return p.then(function () { return post('/cart/change.js', op); }); }, Promise.resolve())
          .then(function () {
            again = true;
            try {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } catch (e) {}
          });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 700); }

  var CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var f0 = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = f0.apply(this, arguments);
    if (CART.test(url)) p.then(schedule, schedule);
    return p;
  };
  var open0 = XMLHttpRequest.prototype.open, send0 = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__gcLogoUrl = u; return open0.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (!this.__gcLogoOwn && CART.test(String(this.__gcLogoUrl || ''))) this.addEventListener('loadend', schedule);
    return send0.apply(this, arguments);
  };
  document.addEventListener('cart:refresh', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
